
import { defineComponent, ref, computed, reactive } from 'vue'
import { debounceRef } from '@/api/tools'
import { searchLocations } from '@/services/map.service'
import { Location } from '@/api/models/Location'

export default defineComponent({
  name: 'PlaceSearch',
  emits: ['selected'],
  setup (props, { emit }) {
    
    const query = ref('')
    const state = reactive<{
      results: Location[];
      isLoading: boolean;
      isActive: boolean;
      current: number;
    }>({
      results: [],
      isLoading: false,
      isActive: false,
      current: 0
    })
    
    const message = computed(() => !state.results.length && query.value && !state.isLoading ? 'Ingen resultater' : '')

    debounceRef(query, async (q) => {      
      if (q) {      
        state.current = 0
        state.isLoading = true
        state.results = await searchLocations(q, 5)
        state.isLoading = false
      }
    }, 500)

    function select(location: Location) {
      emit('selected', location)
      query.value = ''
      state.results = []
    }
    function up() {
      state.current > 0 && state.current--
    }
    function down() {
      state.current < state.results.length - 1 && state.current++
    }
    function enter() {
      const location = state.results[state.current]
      location && select(location)
    }

    return { state, query, up, down, enter, select, message }
  }
})
